import { useEffect } from 'react';
import { App } from 'antd';
import { setNotificationInstance } from '@utils/openNotification';

function NotificationInstanceBinder() {
  const { notification } = App.useApp();

  useEffect(() => {
    setNotificationInstance(notification);
  }, [notification]);

  return null;
}

export default NotificationInstanceBinder;
